<script setup>
import ArticleZone from "@/layouts/ArticleZone.vue";
import { onMounted } from "vue";
import { useArticlesStore } from "@/stores/articles";

const articleStore = useArticlesStore();

onMounted(() => {
  articleStore.getArticles();
});
</script>
<template>
    <ArticleZone>
    <Suspense>
      <template #fallback>
        <div
          v-if="articleStore.pending"
          class="grid ml-[-1.5em] top-6 h-[27rem] mt-[2em]"
        >
          <div
            class="grid grid-cols-2 gap-1 py-2 ml-6 w-8/10 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 overflow-y-auto"
          >
            <div
              v-for="(_, index) in Array(10)"
              :key="index"
              class="border border-[#575041] rounded mr-5 animate-pulse"
            >
              <div class="w-full">
                <div class="flex justify-center">
                  <div class="w-full h-40 bg-[#a49d8f]"></div>
                </div>
                <div class="flex justify-center bg-[#776849] py-2">
                  <div class="h-4 w-3/4 bg-gray-200 rounded"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
  
      <template #default>
        <div class="grid ml-[-1.5em] py-2 top-0 h-[50rem] sm:h-[27rem] md:h-[27rem]">
          <div
            class="grid grid-cols-2 gap-1 py-2 ml-6 w-8/10 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 overflow-y-auto"
          >
            <div
              v-for="article in articleStore.articles"
              :key="article.id"
              class="border border-[#575041] rounded mr-5"
            >
              <div class="w-full">
                <NuxtLink
                  :to="`/article/${article.id}`"
                  class="block text-decoration-none"
                  aria-label="View article details for {{ article.title }}"
                >
                  <NuxtImg
                    :src="article.image"
                    class="w-full h-auto justify-center filter grayscale sepia hue-rotate-180 brightness-75 duration-30 hover:filter-none"
                    :placeholder="[60, 60]"
                  />
                  <div class="flex justify-center bg-[#776849] py-2">
                    <p class="font-mono text-sm text-[#0e0d0d] text-center">
                      {{ article.title }}
                    </p>
                  </div>
                </NuxtLink>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Suspense>
  </ArticleZone>
</template>

<style scoped>
.font-mono {
  font-family: "Courier New", Courier, monospace;
}
</style>
